import React from "react";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import "./Home.css";

// Partials
import NavbarPartial from "./Partials/Navbar";
import InicioPartial from "./Partials/Inicio";
import SobrePartial from "./Partials/Sobre";
import ModulosPartial from "./Partials/Modulos";
import EmpresasPartial from "./Partials/Empresas";
import ContatosPartial from "./Partials/Contatos";
// import BannerPartials from "../../Components/Banner";
import FooterPartial from "./Partials/Footer";


const Home = () => {
  return (
    <>
      <NavbarPartial />
      <Container fluid>
        <InicioPartial />
        <SobrePartial />
        <ModulosPartial />
        <EmpresasPartial />
        {/* <ContatosPartial /> */}
        <FooterPartial />
      </Container>
    </>
  );
};

export default Home;
